










import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'
import ProfileOrder from '@/components/ProfileOrder.vue'

import { ScrollToFetch } from '@/mixins'

@Component({
  components: {
    AppTitleBar,
    ProfileOrder
  },
  apollo: {
    orderConnection: {
      query () {
        return gql`query orderConnection($after: String) {
          orderConnection(after: $after) {
            cursor
            hasNextPage
            orders {
              id
              status
              createdAt
              deliveries {
                id
                name
                status
                seller {
                  id
                  shop {
                    id
                    shoppingMallName
                  }
                }
                orderItems {
                  id
                  status
                  item {
                    id
                    brand {
                      id
                      name
                    }
                    medias {
                      id
                      path
                    }
                  }
                }
              }
            }
          }
        }`
      }
    }
  }
})
export default class extends Mixins(ScrollToFetch) {
  orderConnection = { cursor: null, hasNextPage: false }

  mounted () {
    this.addScrollListener('orderConnection', 'orders')
  }
}
